import React, { Fragment, memo, useEffect, useState } from 'react';
import { Flex, Carousel } from 'antd-mobile';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { ImgWrap, CommonBtn, FrameWork } from 'pubBiz';
import { Player } from 'video-react';
import 'video-react/dist/video-react.css';
import styles from './index.modules.less';

const { Shape } = FrameWork;

const defaultProps = {
  className: '',
  loadEnd: false,
  width: 0,
  height: 0,
  mediasList: [],
  changeBg: null,
  onPress: null
};

const mediasListPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    imgInfo: PropTypes.shape({
      imgUrl: PropTypes.string // String 图片地址
    }),
    imgUrlApp: PropTypes.string, // String 图片地址
    imgType: PropTypes.number, // Number 图片类型 0:图片 1:视频
    videoButtonName: PropTypes.string // String 视频按钮名称
  })
);

const propTypes = {
  loadEnd: PropTypes.bool, // 是否加载完成
  className: PropTypes.string, // 自定义容器类名
  width: PropTypes.any, // 图片宽度
  height: PropTypes.any, // 图片高度
  mediasList: mediasListPropTypes, // 数据源
  changeBg: PropTypes.func, // 切换背景
  onPress: PropTypes.func // 点击事件
};

const BannerCell = memo((props) => {
  const {
    className, // String 自定义容器类名
    loadEnd, // Boolean 是否加载完成
    width, // Any 图片宽度
    height, // Any 图片高度
    mediasList, // Array 数据源
    changeBg, // Function 切换背景
    onPress, // Function 点击事件
    styleImg, // 图片样式
    styleBanner // 轮播图样式
  } = props;
  const [index, setIndex] = useState(1);
  const [hasVideo, setHasVideo] = useState(false);

  useEffect(() => {
    if (mediasList.some((v) => v.imgType == 1)) {
      setHasVideo(true);
    } else {
      setHasVideo(false);
    }
  }, [mediasList]);

  // Banner子项
  const renderItem = (v, i) => {
    const { imgUrlApp, imgInfo, imgType, videoButtonName } = v;
    const { imgUrl } = imgInfo;
    return (
      <div key={`banner_${i}`} className={styles.bannerItem} style={styleImg || {}}>
        {/* 视频 */}
        {imgType == 1 && (
          <Fragment>
            <Player>
              <source src={imgUrl || ''} />
            </Player>
            {videoButtonName && (
              <CommonBtn
                title={videoButtonName}
                className={styles.videoBtn}
                onClick={() => onPress && onPress(v)}
              />
            )}
          </Fragment>
        )}
        {/* 图片 */}
        {imgType != 1 && (
          <div onClick={() => onPress && onPress(v)}>
            <ImgWrap src={imgUrlApp || imgUrl || ''} mode={'cover'} w={width} h={height} />
          </div>
        )}
      </div>
    );
  };

  // 进度条
  const renderProgress = () => {
    return (
      <Flex className={styles.progress}>
        <div
          className={styles.bar}
          style={{
            width: `${(index / mediasList.length) * 100}%`
          }}
        />
      </Flex>
    );
  };

  // 骨架屏
  if (!loadEnd) {
    return <Shape type="square" w={width} h={height} />;
  }

  return (
    <div className={cx(styles.bannerCellContainer, className)} style={styleBanner || {}}>
      <Carousel
        style={{ width, height }}
        autoplay={hasVideo}
        interval={3000}
        infinite
        dots={false}
        afterChange={(index) => {
          changeBg && changeBg(mediasList[index].imgUrl || '');
          setIndex(index + 1);
        }}>
        {mediasList.map((v, i) => renderItem(v, i))}
      </Carousel>
      {renderProgress()}
    </div>
  );
});

BannerCell.defaultProps = defaultProps;
BannerCell.propTypes = propTypes;

export default BannerCell;



// WEBPACK FOOTER //
// ./src/pubBiz/CommonCell/BannerCell/index.js